import { HttpService } from "../http";
import {
  CREATE_SUBSCRIBER,
  DELETE_SUBSCRIBER,
  GET_SUBSCRIBER_COURSES,
  GET_SUBSCRIBER_ENDPOINT,
  GET_SUBSCRIBER_MEMBERS,
  UPDATE_SUBSCRIBER,
  UPDATE_SUBSCRIBER_BY_ID,
  IMPORT_SUBSCRIBERS,
} from "./endpoints";

export class SubscriberService extends HttpService {
  fetchSubscribers = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${GET_SUBSCRIBER_ENDPOINT}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  createSubscriber = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${CREATE_SUBSCRIBER}`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateSubscriber = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${UPDATE_SUBSCRIBER}`;
    try {
      const apiResponse = await this.patch(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateSubscriberById = async (id: number, payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${UPDATE_SUBSCRIBER_BY_ID}/${id}`;
    try {
      const apiResponse = await this.patch(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteSubscriber = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${DELETE_SUBSCRIBER}/${payload}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      console.log(apiResponse);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchSubscriberMembers = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${GET_SUBSCRIBER_MEMBERS}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchSubscriberCourses = async (
    memberID: number,
    payload: any
  ): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${GET_SUBSCRIBER_COURSES}/${memberID}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  enrolledUsers = async (
    courseId: number,
    subscriberId: number,
    payload: any
  ): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses/${courseId}/takers/${subscriberId}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  subscriberJournalist = async (
    courseId: number,
    payload: any
  ): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/organization-membership/journalist/course/${courseId}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  importSubscribers = async (file: File): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${IMPORT_SUBSCRIBERS}`;
    const formData = new FormData();
    formData.append("file", file);
    try {
      const apiResponse = await this.post(baseUrl, formData);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
